import { getThemePreference } from './theme-switcher';

const updateThemeLinks = () => {
    const currentProduct = window.inx?.params?.project?.name;
    const targetProduct = currentProduct === 'news' ? 'portal' : currentProduct === 'portal' ? 'news' : null;
    const theme = getThemePreference();

    if (!targetProduct || !['auto', 'light', 'dark'].includes(theme)) return;

    document.querySelectorAll([
        `.product-${targetProduct} a[href]`,
        `.header-product-${targetProduct} a[href]`,
        `[data-theme-target="${targetProduct}"][href]`
    ].join(', ')).forEach((link) => {
        try {
            const url = new URL(link.href);
            url.searchParams.set('theme', theme);
            link.href = url.toString();
        } catch (error) {
            // Ignore malformed URLs.
        }
    });
};

const initThemeLinks = () => {
    updateThemeLinks();

    document.querySelector('[data-theme-switcher]')?.addEventListener('click', updateThemeLinks);

    const newsContainer = document.querySelector('.wrap-carousel .carousel-inner');
    if (newsContainer) {
        new MutationObserver(updateThemeLinks).observe(newsContainer, { childList: true, subtree: true });
    }
};

export default initThemeLinks;
